import { useLocation } from '@thd-olt-component-react/router';
import { useConfigService } from '@thd-nucleus/experience-context';

export function useSlug(customerType, isNativeApp = false) {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const slugFromQueryParams = searchParams.get('slug');
  const debugTrue = searchParams.get('debug');

  const fsWorkspaceDashboardLayout = useConfigService('fs:workspaceDashboardLayout');
  const fsB2cLayoutTest = useConfigService('fs:b2cLayoutTest');

  /**
   * A slug in the query parameters means someone is trying to preview
   * the page using the preview button in Contentful.
   */
  if (debugTrue === 'true' && slugFromQueryParams) return slugFromQueryParams;

  if (customerType === 'b2b' && fsWorkspaceDashboardLayout) {
    if (isNativeApp) return `native-app-homepage-prod-${fsWorkspaceDashboardLayout}`;

    return `homepage-prod-${fsWorkspaceDashboardLayout}`;
  }

  if (customerType === 'b2c' && fsB2cLayoutTest) {
    if (isNativeApp) return 'native-app-homepage-prod-b2c-layout-test1';

    return 'homepage-prod-b2c-layout-test1';
  }

  if (isNativeApp) return `native-app-homepage-prod-${customerType}`;

  return `homepage-prod-${customerType}`;
}
